import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import {
  addLocationMaster,
  getLocationMasters,
  uploadLocationMasterExcel,
  downloadLocationMasterSample,
} from "./locationMasterAPI";

const initialState = {
  loading: false,
  uploadLoading: false,
  locationMasterList: [],
  pagination: {},
};

const actions = {
  CREATE_LOCATION_MASTER: "locationMaster/CREATE_LOCATION_MASTER",
  GET_LOCATION_MASTERS: "locationMaster/GET_LOCATION_MASTERS",
  UPLOAD_EXCEL: "locationMaster/UPLOAD_EXCEL",
  DOWNLOAD_SAMPLE: "locationMaster/DOWNLOAD_SAMPLE",
};

export const createLocationMasterThunk = createAsyncThunk(
  actions.CREATE_LOCATION_MASTER,
  async (payload) => {
    const response = await addLocationMaster(payload);
    return response;
  }
);

export const getLocationMastersThunk = createAsyncThunk(
  actions.GET_LOCATION_MASTERS,
  async (payload) => {
    const response = await getLocationMasters(
      payload?.page,
      payload?.per_page,
      payload?.search
    );
    return response;
  }
);

export const uploadLocationMasterExcelThunk = createAsyncThunk(
  actions.UPLOAD_EXCEL,
  async (formData) => {
    const response = await uploadLocationMasterExcel(formData);
    return response;
  }
);

export const downloadLocationMasterSampleThunk = createAsyncThunk(
  actions.DOWNLOAD_SAMPLE,
  async () => {
    const response = await downloadLocationMasterSample();
    return response;
  }
);

export const locationMasterSlice = createSlice({
  name: "locationMaster",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get location masters
    builder
      .addCase(getLocationMastersThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLocationMastersThunk.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg, data } = action.payload || {};
        if (success) {
          state.locationMasterList = data?.data || [];
          state.pagination = data?.pagination || {};
        } else {
          message.error(msg || "Failed to fetch Site Masters.");
        }
      })
      .addCase(getLocationMastersThunk.rejected, (state, action) => {
        state.loading = false;
        message.error(action.error.message || "Failed to fetch Site Masters.");
      });

    // Create location master
    builder
      .addCase(createLocationMasterThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(createLocationMasterThunk.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg } = action.payload || {};
        if (success) {
          message.success(msg || "Site Master created successfully!");
        } else {
          message.error(msg || "Failed to create Site Master.");
        }
      })
      .addCase(createLocationMasterThunk.rejected, (state, action) => {
        state.loading = false;
        message.error(action.error.message || "Failed to create Site Master.");
      });

    // Upload excel
    builder
      .addCase(uploadLocationMasterExcelThunk.pending, (state) => {
        state.uploadLoading = true;
      })
      .addCase(uploadLocationMasterExcelThunk.fulfilled, (state, action) => {
        state.uploadLoading = false;
        if (action.payload?.success) {
          message.success(action.payload?.message || "Sites uploaded successfully!");
        } else if (action.payload?.success === false) {
          message.error(action.payload?.message || "Failed to upload Site Masters.");
        }
      })
      .addCase(uploadLocationMasterExcelThunk.rejected, (state, action) => {
        state.uploadLoading = false;
        message.error(action.error.message || "Failed to upload Excel file.");
      });
  },
});

export default locationMasterSlice.reducer;
